import React, { Fragment, useCallback, useState } from 'react';
import Container from './RequiredDocumentContainer';
import { useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import Portal from '../../../../../utils/portal/Portal';
import { areas } from 'constants/areas';
import { getInt } from '../../../../../utils/functions';
import Header from './header/Header';
import HeaderLinks from './header/HeaderLinks';
import { withAreaGetter } from '../../../../../providers/AreasConsumers';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_REQUIRED_DOCUMENTS } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();
  const match = useRouteMatch();
  const [title, setTitle] = useState('');
  const id = match.params.id && getInt(match.params.id);

  const onClickClose = () => {
    historyContext.push(`/requiredDocuments`);
  };

  const onChangeRequiredDocumentTitle = requiredDocumentTitle => {
    setTitle(requiredDocumentTitle);
  };

  const onRedirect = useCallback(
    id => {
      historyContext.push(`/requiredDocuments/${id}`);
    },
    [historyContext]
  );

  return (
    <Fragment>
      <Portal container={getElemByAreaKey(areas.header)}>
        <Header title={title} />
      </Portal>
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <HeaderLinks onClickClose={onClickClose} />
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_REQUIRED_DOCUMENTS}>
        <Container id={id} onChangeRequiredDocumentTitle={onChangeRequiredDocumentTitle} onRedirect={onRedirect} />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
